import Vue from 'vue';
export const EventBus = new Vue({
    data: {
        modelIndex: null,    // 产品中心轮播的当前产品index
        currentSeries: null,
        currentSeriesViewType: null,
    },
    methods: {
        changeModelIndex: function (index) {
          console.log('changeModelIndex: , ', index)
          this.modelIndex =  index
        },

        changeCurrentSeries: function (s) {
          console.log('changeCurrentSeries: , ', s)
          this.currentSeries =  s
        },

        changeCurrentSeriesViewType: function (t) {
          console.log('changeCurrentSeriesViewType: , ', t)
          this.currentSeriesViewType =  t
        }
    }
});